import React from "react";

import { useDictionary } from "hooks";

import styles from "./styles.css";

const defaultDictionary = {
    title: "Another user made changes to the same field(s). Review the impacted field(s) below. If your change is still desired, re-enter your value into the field.",
    enteredValue: "Your entered value",
    currentValue: "Current value",
};

export const ConflictsModal = ({ fields }) => {
    const dictionary = useDictionary("common.conflictsModal");

    return (
        <React.Fragment>
            <h4 className={styles.title}>
                {dictionary.title || defaultDictionary.title}
            </h4>
            <ul className={styles.list}>
                {fields.map((item, k) => (
                    <li key={k}>
                        <p>
                            {item.sectionName ? `${item.sectionName}:` : ''} {item.fieldName}
                        </p>
                        {/* {!item.hideValues && (
                            <>
                                <p>
                                    Your entered value:{" "}
                                    <span>{JSON.stringify(item.value)}</span>
                                </p>
                                <p>
                                    Current value:{" "}
                                    <span>{JSON.stringify(item.oldValue)}</span>
                                </p>
                            </>
                        )} */}
                    </li>
                ))}
            </ul>
        </React.Fragment>
    );
};
